/*! Copyright (c) 2016 Naufal Rabbani (http://github.com/BosNaufal)
 * Licensed Under MIT (http://opensource.org/licenses/MIT)
 *
 * Vue Click Outside - Version@1.0.0
 *
 */
import Vue from 'vue'
// Directive for outside click detections
var VueClickOutSide = {
    id: 'clickoutside',
    bind (el, props) {
        el.clickCatcher = function (e) {
            if (props.modifiers.hidden) {
                // .hidden modifier is required when target component is hidden using v-if or v-show
                props.modifiers.hidden = false
                return
            }
            if (!el.contains(e.target) && typeof props.value === 'function') {
                props.value(props.arg)
            }
        }
        window.addEventListener('click', el.clickCatcher)
    },
    unbind: el => window.removeEventListener('click', el.clickCatcher),
    install (Vue) {
        Vue.directive('clickoutside', {
            bind: this.bind,
            unbind: this.unbind
        })
    }
}
export default VueClickOutSide


// WEBPACK FOOTER //
// ./src/components/userSelect/vue-click-outside.js